export var AnalyticsPagesForTracking;
(function (AnalyticsPagesForTracking) {
    AnalyticsPagesForTracking["USAGE"] = "usage";
    AnalyticsPagesForTracking["MEETING_HISTORY"] = "meeting history";
})(AnalyticsPagesForTracking || (AnalyticsPagesForTracking = {}));
export var DatePeriod;
(function (DatePeriod) {
    DatePeriod["PAST_7_DAYS"] = "DATEPICKER/PAST_7_DAYS";
    DatePeriod["THIS_MONTH"] = "DATEPICKER/THIS_MONTH";
    DatePeriod["PAST_MONTH"] = "DATEPICKER/PAST_MONTH";
    DatePeriod["PAST_3_MONTH"] = "DATEPICKER/PAST_3_MONTH";
    DatePeriod["PAST_6_MONTH"] = "DATEPICKER/PAST_6_MONTH";
    DatePeriod["PAST_12_MONTH"] = "DATEPICKER/PAST_12_MONTH";
    DatePeriod["ALL_TIME"] = "DATEPICKER/ALL_TIME";
})(DatePeriod || (DatePeriod = {}));
export const DatePeriodTrackingName = {
    [DatePeriod.PAST_7_DAYS]: 'past 7 days',
    [DatePeriod.THIS_MONTH]: 'current month',
    [DatePeriod.PAST_MONTH]: 'past month',
    [DatePeriod.PAST_3_MONTH]: 'past 3',
    [DatePeriod.PAST_6_MONTH]: 'past 6',
    [DatePeriod.PAST_12_MONTH]: 'past 12',
    [DatePeriod.ALL_TIME]: 'all time',
};
